import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import { lazy, useEffect, useState, useTransition, } from 'react';
import { contract } from '@aviv_price-pages/brand';
import { useThorEvent } from '@aviv-dxp/react-thor';
import { Box } from '@gemini/core';
import { usePageLayoutContext } from '@/hooks/usePageLayoutContext/usePageLayoutContext';
import { Logger } from '@/logger';
export const AgencyCardMap = ({ id }) => {
    const { microFrontends } = contract;
    const { pricePageProps: { pricePageContext }, } = usePageLayoutContext();
    const [AcDataProvider, setAcDataProvider] = useState(null);
    const [AcStandalone, setAcStandalone] = useState(null);
    const [isPending, startTransition] = useTransition();
    const [isMfeLoaded, setIsMfeLoaded] = useState(false);
    const agencyCardMapViewItemEvent = useThorEvent({
        eventData: {
            event: 'view_item',
            av_category: '',
            av_items: [],
        },
    });
    const lazyLoadComponent = (component) => lazy(() => import('mfe_avis_pricePagesAgencyCards')
        .then((module) => ({ default: module[component] }))
        .catch((error) => {
        Logger.error(error);
        return { default: () => _jsxs("div", { children: ["Error loading ", component] }) };
    }));
    useEffect(() => {
        if (typeof window !== 'undefined') {
            startTransition(() => {
                setAcDataProvider(lazyLoadComponent('DataProvider'));
                setAcStandalone(lazyLoadComponent('Standalone'));
            });
        }
    }, []);
    useEffect(() => {
        if (AcDataProvider && AcStandalone) {
            setIsMfeLoaded(true);
        }
    }, [AcDataProvider, AcStandalone]);
    useEffect(() => {
        if (!isMfeLoaded)
            return;
        const onAnalytics = (
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        event) => {
            const { detail } = event;
            if (!detail)
                return;
            const eventProps = {
                ...detail,
                av_geolocation_level: pricePageContext.place.type,
                av_category: 'price_map',
            };
            agencyCardMapViewItemEvent({
                eventData: {
                    ...eventProps,
                },
            });
        };
        const agencyCardComponent = document.getElementById('agencyCardMap-container');
        agencyCardComponent?.addEventListener('agencyCard:onAnalytics', onAnalytics);
        return () => {
            agencyCardComponent?.removeEventListener('agencyCard:onAnalytics', onAnalytics);
        };
    }, [isMfeLoaded, pricePageContext.place.type, agencyCardMapViewItemEvent]);
    if (!microFrontends?.mfe_avis_pricePagesAgencyCards) {
        return;
    }
    return isPending || !AcDataProvider || !AcStandalone ? (_jsx("div", { children: "Loading..." })) : (_jsx(Box, { "data-test": "AcSidePanel", id: "agencyCardMap-container", children: _jsx(AcDataProvider, { agencyId: id, children: _jsx(AcStandalone, { agencyId: id }) }) }));
};
